// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__264CY","footer":"ModalCreateQualiphyProcedure_footer__1SR91","additionData":"ModalCreateQualiphyProcedure_additionData__glfK8"};